import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "CountryStateControl",
  class: "SelectionDetailsBlock"
}
const _hoisted_2 = {
  key: 1,
  class: "SelectionDetailsWarningMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectedCountryCounter = _resolveComponent("SelectedCountryCounter")!
  const _component_SetSelectedCountryLevel = _resolveComponent("SetSelectedCountryLevel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SelectedCountryCounter),
    (_ctx.numCheckedCountries > 0)
      ? (_openBlock(), _createBlock(_component_SetSelectedCountryLevel, { key: 0 }))
      : (!_ctx.doSelectedEntitiesHaveTheSameTargeting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "lnr-warning SelectionWarningIcon" }, null, -1 /* CACHED */),
            _createElementVNode("span", null, " Since the selected organisations and studies do not have the same targeting per country, the default targeting that is displayed here for all countries is \"basic\". ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true)
  ]))
}